import { useLocation } from "@gatsbyjs/reach-router"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { connect } from "react-redux"
import { getTransferId } from "../helpers/routing"
import { requestFetchTransfer } from "../state/modules/transfer"
import { resetLastDownload } from "../state/modules/download"
import DownloadTransferContent from "./DownloadTransferContent"
import DownloadTransferMessage from "./DownloadTransferMessage"
import CustomBackgroundImage from "./CustomBackgroundImage"
import App from "./App"
import TopBar from "./TopBar"

const DownloadPageContent = ({
  shortUrl,
  transfers,
  lastDownload,
  fetchTransfer,
  resetDownload,
  sagaReady,
}) => {
  const { pathname } = useLocation()
  const transferId = shortUrl || getTransferId(pathname)
  const [isFetching, setIsFetching] = useState(false)

  const { t, i18n: { language } } = useTranslation("generic")

  useEffect(() => {
    if (sagaReady && !transfers[transferId] && !isFetching) {
      if (transferId) {
        // without this guard, fetchTransfer is called twice because of the transfers dependency
        setIsFetching(true)
        fetchTransfer(transferId, language)
      }
    }
  }, [transferId, transfers, fetchTransfer, sagaReady, isFetching, language])

  useEffect(() => {
    return resetDownload
  }, [resetDownload])

  const transfer = transfers[transferId]
  const isInProgress = lastDownload === transferId

  return (
    <App>
      <TopBar />
      <div>
        <CustomBackgroundImage url={transfer?.background} />
        {!transfer && <DownloadTransferMessage />}
        {transfer?.isInvalidUrl && (
          <DownloadTransferMessage message={t("##.Download.InvalidDownload")} />
        )}
        {transfer?.status?.isExpired && (
          <DownloadTransferMessage
            message={t("##.Download.DownloadNotAvailable")}
          />
        )}
        {transfer?.status?.isDefective && (
          <DownloadTransferMessage
            message={t("##.Download.DownloadDefective")}
          />
        )}
        {transfer?.status?.isCancelled && (
          <DownloadTransferMessage
            message={t("##.Download.DownloadCancelled")}
          />
        )}
        {isInProgress && (
          <DownloadTransferMessage
            message={t("##.Download.DownloadStartedMessage")}
          />
        )}
        {!isInProgress && transfer?.status?.isAvailable && (
          <DownloadTransferContent transfer={transfer} />
        )}
      </div>
    </App>
  )
}

const mapStateToProps = state => {
  return {
    transfers: state.transfer.download,
    lastDownload: state.download.lastDownloadRequest,
    sagaReady: state.ready.sagasInitialized,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchTransfer: (shortUrl, language) =>
      dispatch(requestFetchTransfer(shortUrl, "download", language)),
    resetDownload: () => dispatch(resetLastDownload()),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(DownloadPageContent)
